import {
  Component,
  computed,
  DestroyRef,
  effect,
  inject,
  input,
  model,
  output,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { OF } from "../../models/of.model";
import { OfService } from "../../services/of.service";
import { ArticlesInfosFacadeService } from "app/features/articles/services/article-infos/article-infos-facade.service";
import { SharedModule } from "../../../../shared/shared.module";
import { BioLogoComponent } from "../../../../shared/components/bio-logo/bio-logo.component";
import { MatIconButton } from "@angular/material/button";
import { DatePipe } from "@angular/common";

@Component({
  selector: "vl-of-card",
  standalone: true,
  imports: [SharedModule, BioLogoComponent, MatIconButton, DatePipe],
  templateUrl: "./of-card.component.html",
  styleUrls: ["./of-card.component.scss"],
})
export class OfCardComponent {
  facade = inject(ArticlesInfosFacadeService);
  ofService = inject(OfService);
  router = inject(Router);
  private destroyRef = inject(DestroyRef);

  fo = input<OF>();
  ofId = input<string>();
  actions = input<boolean>(false);
  route = input<string>();

  currentOf = model<OF>(null);
  simpleWithDate = input<boolean>(false);

  action = output();

  articleInfos = computed(() => {
    if (this.currentOf()) {
      return this.facade.getByArticleId(this.currentOf().articleId)();
    }
    return null;
  });

  constructor() {
    effect(
      () => {
        if (this.ofId()) {
          this.ofService._loadEagerById(this.ofId())
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((of) => {
              this.currentOf.set(of);
            });
        }
      },
      { allowSignalWrites: true },
    );
    effect(
      () => {
        if (this.fo()) {
          this.currentOf.set(this.fo());
        }
      },
      { allowSignalWrites: true },
    );
  }

  go() {
    this.router.navigate([this.route() ?? `/productions/suivi/ope`], {
      queryParams: { ofId: this.currentOf().id },
    });
    this.action.emit();
  }
}
